import { getUserInfo } from "auth/store/authenticationSlice";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";

const useUserTenants = () => {
  const dispatch = useAppDispatch();
  const { isLoading, error, isReloadNeeded, tenants } = useAppSelector(
    (state) => state.common.authentication
  );

  useEffect(() => {
    if (!isLoading && !error && isReloadNeeded) dispatch(getUserInfo());
  }, [dispatch, error, isLoading, isReloadNeeded]);

  return tenants;
};

export default useUserTenants;
